import axios, { AxiosInstance } from "axios";
import { useAuth } from "@/stores/auth";
import router from "../router";
import { useToast } from "vue-toast-notification";

const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const toast = useToast();
    const auth = useAuth();

    if (error.response?.status) {
      if (error.response.status === 401) {
        auth.clearCredentials();
        router.push({ name: "Login" });
      } else {
        toast.error(JSON.stringify(error), { position: "bottom" });
      }

      throw new Error(JSON.stringify(error.response));
    }

    toast.error(JSON.stringify(error), { position: "bottom" });
    throw error;
  },
);

export default apiClient;
